import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import _ from "lodash";
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import {confirmAlert} from "react-confirm-alert";
import AgenciesAdd from './../../elements/agencies/widget/agencies_add';
import AgenciesSearch from "../../elements/agencies/widget/agencies_search";

class Agencies extends Component {
	render(){
		return(
			<AgenciesList {...this.props}/>
		);
	}

	componentWillMount(){
		const { agencies } = this.props;
		this.props.agenciesShow(agencies.pages.current, agencies.filters);
	}
}

export class AgenciesList extends Component{
	render() {
		const { agencies } = this.props;
		let au = _.find(agencies.permissions, (o) => {return o==='Update'});
		let ad = _.find(agencies.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{agencies.isFetching ? <Loading/> :
					[<table className={`inm-table`} key="agencies-table">
						<thead>
						<tr>
							<th>ID</th>
							<th>Nombre</th>
							<th>Estado</th>
							<th>Tipo de instancia</th>
							<th>Versión</th>
						</tr>
						</thead>
						<tbody>
						{_.map(_.orderBy(agencies.list, ['id']), (row, k) => {
							return (
								<tr key={k}>
									<td style={{width: 10 + '%'}}>
										<div className="actions">
											{au ? <NavLink to={`/instancias/editar/${row.id}`}><i
												className="fa fa-edit"></i></NavLink> : ''}
											{ad ? <button onClick={() => this._getConfirm(row.id, row.name)}><i
												className="fa fa-trash-o"></i></button> : ''}
										</div>
										{row.id}
									</td>
									<td><strong>{row.name}</strong></td>
									<td>{row.agenciable && row.agenciable.state ? row.agenciable.state.name:row.agenciable ? row.agenciable.name:'---'}</td>
									<td>{_.upperCase(row.agenciable_type ? row.agenciable_type : '')}</td>
									<td>{row.version ? row.version.year:'---'}</td>
								</tr>
							)
						})}
						</tbody>
					</table>,
						agencies.pages.total > 20 &&
						<InmPagination key="agencies-pages"
						               current={agencies.pages.current}
						               total={agencies.pages.total}
						               nextPage={this._handlePageChange}
						/>
					]}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la instancia "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.agencyDelete(id)
		})
	}

	_handlePageChange(value) {
		const { agencies } = this.props;
		this.props.agenciesShow(value, agencies.filters);
	}
}

export default BaseLayout(Agencies, {
	title: `Administrar Instancias`,
	subnav: {
		icon: 'fa fa-map-marker',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <AgenciesSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <AgenciesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/agencies/index.jsx